var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlinePath2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87 22.75c-1.02 0-1.96-.43-2.56-1.19-.53-.66-.72-1.5-.54-2.3l.69-3.08c.08-.34.38-.58.73-.58h7.64c.35 0 .65.24.73.58l.7 3.08c.19.86.01 1.69-.51 2.34-.58.73-1.53 1.15-2.6 1.15H9.87zM8.23 19.6c-.08.36.01.72.25 1.03.31.39.83.62 1.39.62h4.29c.61 0 1.13-.21 1.42-.58.24-.29.31-.67.22-1.07l-.56-2.5H8.79l-.56 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 16.91 4.75 14.3c-1.93-1.59-2.09-3.13-.5-5.15l5.19-6.58c.67-.85 1.59-1.32 2.57-1.32.99 0 1.9.47 2.57 1.32l5.19 6.58c1.57 1.99 1.43 3.44-.5 5.15l-2.94 2.61c-.31.27-.79.25-1.06-.06a.756.756 0 0 1 .06-1.06l2.94-2.61c1.32-1.17 1.38-1.75.32-3.1L13.41 3.5c-.76-.97-2.03-.97-2.79 0l-5.19 6.58c-1.09 1.38-1.04 1.99.29 3.08l2.96 2.63c.31.27.34.75.06 1.06a.73.73 0 0 1-.55.25c-.18 0-.36-.06-.5-.19z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.26 6.97v-4.3c0-.41.34-.75.75-.75s.75.34.75.75v4.3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87 22.75c-1.02 0-1.96-.43-2.56-1.19-.53-.66-.72-1.5-.54-2.3l.69-3.08c.08-.34.38-.58.73-.58h7.64c.35 0 .65.24.73.58l.7 3.08c.19.86.01 1.69-.51 2.34-.58.73-1.53 1.15-2.6 1.15H9.87zM8.23 19.6c-.08.36.01.72.25 1.03.31.39.83.62 1.39.62h4.29c.61 0 1.13-.21 1.42-.58.24-.29.31-.67.22-1.07l-.56-2.5H8.79l-.56 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 16.91 4.75 14.3c-1.93-1.59-2.09-3.13-.5-5.15l5.19-6.58c.67-.85 1.59-1.32 2.57-1.32.99 0 1.9.47 2.57 1.32l5.19 6.58c1.57 1.99 1.43 3.44-.5 5.15l-2.94 2.61c-.31.27-.79.25-1.06-.06a.756.756 0 0 1 .06-1.06l2.94-2.61c1.32-1.17 1.38-1.75.32-3.1L13.41 3.5c-.76-.97-2.03-.97-2.79 0l-5.19 6.58c-1.09 1.38-1.04 1.99.29 3.08l2.96 2.63c.31.27.34.75.06 1.06a.73.73 0 0 1-.55.25c-.18 0-.36-.06-.5-.19z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.26 6.97v-4.3c0-.41.34-.75.75-.75s.75.34.75.75v4.3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePath2);
export default __webpack_public_path__ + "static/media/vuesax-outline-path-2.25591c5387a099e3ef77106f268847d2.svg";
export { ForwardRef as ReactComponent };